import React, { useState } from 'react';
import { Tabs } from 'antd';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { IoLocationSharp, IoCall } from "react-icons/io5";
import { IoIosPhonePortrait } from "react-icons/io";
import { CiMail } from "react-icons/ci";
import Map from "../../FourthComponents/Map/Map"

const ContactTabs = (props) => {
    const [activeKey, setActiveKey] = useState("1");
    const history = useHistory()
    const { selectedLanguage, language } = props
    const isELSelect = language?.language === 'english'
    const isAlSelect = language?.language === 'arabic'
    const onChange = (key) => {
        setActiveKey(key);
    };
    const tabData = [
        {
            id: 1,
            label: selectedLanguage?.txt_netherlands,
            content: <div className='contact-tab-div'>
                <h2>
                    {selectedLanguage?.txt_amsterdam_clinics_head_office}
                </h2>
                <p>
                    <button>
                        <IoLocationSharp />
                    </button>{selectedLanguage?.txt_address_po_box}
                </p>
            </div>
        },
        {
            id: 2,
            label: selectedLanguage?.txt_alexandria,
            content: <div className='contact-tab-div'>
                <h2>
                    {selectedLanguage?.txt_amsterdam_clinics_sehaty_alexandria}
                </h2>
                <p>
                    <button>
                        <IoLocationSharp />
                    </button>364 {selectedLanguage?.txt_address_el_naql}
                </p>
                <p>
                    <button>
                        <IoCall />
                    </button>+203 422 6 200 / 422 6 202
                </p>
                <p>
                    <button>
                        <IoIosPhonePortrait />
                    </button>+2 010 210 55 271 / 010 210 55 272
                </p>
                <p>
                    <button>
                        <CiMail />
                    </button>info@amsterdamclinics.com
                </p>
                <Map />
            </div>
        },
        {
            id: 3,
            label: selectedLanguage?.txt_cairo,
            content: <div className='contact-tab-div'>
                <h2>
                    {selectedLanguage?.txt_second_branch}
                </h2>
                <p>
                    <button>
                        <IoLocationSharp />
                    </button>{selectedLanguage?.txt_address_petrosport}
                </p>
                <p>
                    <button>
                        <IoIosPhonePortrait />
                    </button>+20 1021055274
                </p>
                <Map />
            </div>
        },
        {
            id: 4,
            label: selectedLanguage?.txt_saudi_arabia,
            content: <div className='contact-tab-div'>
                <h2>
                    {selectedLanguage?.txt_amsterdam_clinics_saudi_arabia_coming_soon}
                </h2>
                <p>
                    <button>
                        <IoLocationSharp />
                    </button>{selectedLanguage?.txt_location_riyadh}
                </p>
                <Map />
            </div>
        },
    ];
    return (
        <div>
            <Tabs
                className='contact-tabs-div'
                activeKey={activeKey}
                defaultActiveKey="1"
                items={tabData.map(tab => ({
                    label: (
                        <span
                            className={tab.id.toString() === activeKey ? "fifth-des-contact-active-tab fifth-des-contact-tab-label" : "fifth-des-contact-tab-label"}
                            onClick={() => onChange(tab.id.toString())}
                        >
                            {tab.label}
                        </span>
                    ),
                    key: tab.id.toString(),
                    children: tab.content,
                }))}
            />
        </div>
    )
};

export default ContactTabs;
